/* tslint:disable */

/**
 */
export class MachineLogin {
    rfid_user?: string;
    pin_code?: string;
    rfid_vehicle?: string;
}
